import { createRandomInRange, createRandomPointInAnnulus, getRandomPointOnSphere, getUniformlyDistributedPointsOnSphere } from "@/utils/math";
import Point from "./point";
import * as THREE from 'three';

export default class Particles {
    pointList: Point[] = []
    state: 'RUNNING' | 'SUSPEND' = 'RUNNING'
    count: number = 0;
    timestamp: number = 0;
    lastTimestamp: number = 0;
    addFloatUpPoint: (timestamp: number) => void;
    constructor() {
        this.init();
        this.addFloatUpPoint = this.createInterval(this.pushFloatUpPoint, 100);
    }
    start() {
        this.state = 'RUNNING';
        requestAnimationFrame(this.animate);
    }
    pause() {
        this.state = 'SUSPEND';
    }
    
    animate(timestamp: number) {
        if (this.state === 'SUSPEND') return;
        if (!this.timestamp) this.timestamp = timestamp;
        const deltaTime = timestamp - this.lastTimestamp;
        this.lastTimestamp = timestamp;
        this.pointList.forEach(point => point.update(timestamp, deltaTime));
        this.clearPoint();
        this.addFloatUpPoint(timestamp);
    }
    getInfo() {
        const position = this.pointList.reduce((p, c) => [...p, ...c.getPosition()], []);
        const color = this.pointList.reduce((p, c) => {
            const color = new THREE.Color(c.color);
            return [...p, ...[color.r, color.g, color.b]];
        }, [])
        const size = this.pointList.map(point => point.size);
        const opacity = this.pointList.map(point => point.opacity);
        return { 
            position: new THREE.Float32BufferAttribute(position, 3), 
            color: new THREE.Float32BufferAttribute(color, 3),
            size: new THREE.Float32BufferAttribute(new Float32Array(size), 1),
            opacity: new THREE.Float32BufferAttribute(new Float32Array(opacity), 1),
        }
    }
    animateAndInfo(timestamp: number) {
        this.animate(timestamp);
        return this.getInfo();
    }

    init() {
        this.initFloatUpPoint();
        // this.initCirculatePoint();
    }

    initFloatUpPoint() {
        for (let i = 0; i < 10; i++) {
            this.pushFloatUpPoint();
        }
    }

    initCirculatePoint() {
        const list = getUniformlyDistributedPointsOnSphere(0, 1, 0, 3.4, 100);
        list.forEach(point => {
            point = point.map(value => value += createRandomInRange(-0.05, 0.05)) as [number, number, number]
            this.pointList.push(new Point({ 
                initPosition: new THREE.Vector3(...point), 
                color: 0xfefadb,
                animation: 'shake',
                size: createRandomInRange(0.2, 0.5),
            }));  
        })
    }

    pushFloatUpPoint = () => {
        const [x, z] = createRandomPointInAnnulus(3, 5);
        this.pointList.push(new Point({ 
            initPosition: new THREE.Vector3(x, createRandomInRange(-6, 10), z), 
            color: 0xfefadb,
            animation: 'floatUp',
            size: createRandomInRange(0.3, 0.7),
        }));      
    }

    createInterval(func: Function, interval: number) {
        let lastExecution = this.timestamp;
        return (timestamp: number) => {
            if (timestamp - lastExecution > interval) {
                lastExecution = timestamp;
                func();
            }
        }
    }

    clearPoint() {
        this.pointList = this.pointList.filter(item => !item.needClear);
    }
}